import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disableInitialInputFocus", "disabled", "error", "messageText", "onChange", "onInputBlur", "onInputFocus", "onKeyDown", "validationMessage", "showQuickReplyPlaceholder", "onPaste", "isIOSMobile"];
import { forwardRef } from 'react';
import I18n from 'I18n';
import { ChatWidgetLocaleContextConsumer } from '../../locale/ChatWidgetLocaleContext';
// @ts-expect-error not typed
import withBlurHandler from 'conversations-visitor-experience-components/visitor-widget/util/withBlurHandler';
import VizExFormControl from 'visitor-ui-component-library/form-control/VizExFormControl';
import VizExExpandingInput from 'visitor-ui-component-library/input/VizExExpandingInput';
import { isMobileDevice } from 'conversations-visitor-experience-components/visitor-widget/util/isMobileDevice';
import { jsx as _jsx } from "react/jsx-runtime";
const BlurableTextArea = withBlurHandler(VizExExpandingInput);
const TextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      disableInitialInputFocus,
      disabled,
      error,
      messageText,
      onChange,
      onInputBlur,
      onInputFocus,
      onKeyDown,
      validationMessage,
      showQuickReplyPlaceholder,
      onPaste,
      isIOSMobile
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldAutofocus = !(disableInitialInputFocus || isMobileDevice() || disabled);
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => /*#__PURE__*/_jsx(VizExFormControl, {
      "aria-label": I18n.text(showQuickReplyPlaceholder ? 'conversations-visitor-ui.chatTextArea.forceQuickReplyPlaceholder' : 'conversations-visitor-ui.chatTextArea.placeholderAskMeAnything', {
        locale
      }),
      validationMessage: validationMessage,
      error: error,
      required: true,
      children: inputArgs => /*#__PURE__*/_jsx(BlurableTextArea, Object.assign({}, inputArgs, {
        use: "unstyled",
        error: error,
        className: "widget-textarea message-box",
        "data-test-id": "widget-textarea",
        tabIndex: "0",
        ref: ref,
        maxHeight: 100,
        placeholder: I18n.text(showQuickReplyPlaceholder ? 'conversations-visitor-ui.chatTextArea.forceQuickReplyPlaceholder' : 'conversations-visitor-ui.chatTextArea.placeholderAskMeAnything', {
          locale
        }),
        disabled: disabled,
        onChange: onChange,
        onKeyDown: onKeyDown,
        value: messageText,
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        onPaste: onPaste,
        shouldAutofocus: shouldAutofocus,
        style: {
          fontSize: isIOSMobile && '16px'
        }
      }, rest))
    })
  });
});
TextInput.displayName = 'TextInput';
export default TextInput;